'use client';

import { useCallback } from 'react';

const useGetNumberFormatters = () => {
  const getFormattedNumber = useCallback((value: number) => {
    return Math.round(value).toLocaleString();
  }, []);

  const getFormattedCurrency = useCallback((value: number) => {
    return value.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }, []);

  return {
    getFormattedNumber,
    getFormattedCurrency,
  };
};

export default useGetNumberFormatters;
